import { render, staticRenderFns } from "./resumePushDetail.vue?vue&type=template&id=32070c76&scoped=true"
import script from "./resumePushDetail.vue?vue&type=script&lang=js"
export * from "./resumePushDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32070c76",
  null
  
)

export default component.exports